export const FOOD_PREFERENCE_FILTERS = "foodPreferenceFilters";
export const MEALS_TAG = "mealsTag";
export const CODE_PROMO = "codePromo";
export const DEFAULT_PROMOTION = "promotion";
export const CLIENT_IP = "ip";
